module.exports = __webpack_public_path__ + "img/Landing Page.4880d8ec.svg";